/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const PlayIcon = createIcon('0 0 20 20', <path d="M19 10 5 18V2z" />);
